/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Archive_Done_With_PortalsInputs */

const cs_property_archive_done_with_portals = /** @type {(inputs: Property_Archive_Done_With_PortalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nemovitost archivována, skryta na webu a odebrána z portálů.`)
};

const en_property_archive_done_with_portals = /** @type {(inputs: Property_Archive_Done_With_PortalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Property archived, hidden on the website, and removed from portals.`)
};

/**
* | output |
* | --- |
* | "Property archived, hidden on the website, and removed from portals." |
*
* @param {Property_Archive_Done_With_PortalsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_archive_done_with_portals = /** @type {((inputs?: Property_Archive_Done_With_PortalsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Archive_Done_With_PortalsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_archive_done_with_portals(inputs)
	return cs_property_archive_done_with_portals(inputs)
});